export default theme => ({
  container: {
    position: 'relative',
    background: 'linear-gradient(145deg, rgba(238,243,248,1) 0%, rgba(205,222,236,1) 100%)',
  },
});
